@file:OptIn(InternalResourceApi::class)

package qualityassurancehelper.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/qualityassurancehelper.composeapp.generated.resources/"

internal val Res.drawable.back_arrow: DrawableResource by lazy {
      DrawableResource("drawable:back_arrow", setOf(
        ResourceItem(setOf(), "${MD}drawable/back_arrow.xml", -1, -1),
      ))
    }

internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

internal val Res.drawable.json_format: DrawableResource by lazy {
      DrawableResource("drawable:json_format", setOf(
        ResourceItem(setOf(), "${MD}drawable/json-format.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectWebMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("back_arrow", Res.drawable.back_arrow)
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("json_format", Res.drawable.json_format)
}
